<template>
  <app-status-chip :statuses="statuses" :value="value" />
</template>

<script>
export default {
  props: {
    value: {},
  },

  data: () => ({
    statuses: {
      foreseen: {
        text: "Previsão",
        color: "disabled",
      },
      renegotiated: {
        text: "Renegociado",
        color: "disabled",
      },
      to_pay: {
        text: "A Pagar",
        color: "secondary",
      },
      paid: {
        text: "Pago",
        color: "primary",
      },
      canceled: {
        text: "Cancelado",
        color: "danger",
      },
    },
  }),
};
</script>

<style>
</style>